import { makeStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    width: '100%',
    height: '90%'
  },
  modalHeader: {
    marginBottom: theme.spacing(6),
    fontSize: 40,
    fontWeight: 300
  },
  modalContent: {
    lineHeight: 1.2,
    display: 'block'
  },
  tab: {
    fontSize: 12,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },
  card: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: theme.spacing(3),
    backgroundColor: theme.colors.page__background_primary,
    minHeight: 72,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(8),
    boxShadow: 'none'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(4),
    alignItems: 'center'
  },
  cardText: {
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      padding: theme.spacing(2, 0)
    }
  },
  cardHeader: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.43
  },
  notificationIcon: {
    display: 'block',
    height: 32,
    width: 32
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2)
  },
  closeBtn: {
    padding: theme.spacing(1, 2),
    marginTop: theme.spacing(8),
    width: 75,
    height: 36
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: theme.spacing(4),
    textAlign: 'center'
  }
});

export default makeStyles(styles);
